function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#020000"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.044718 .51461)"
}, /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(-.78447 .62017 -.64278 -.76605 0 0)",
  x: -4.2139,
  y: -5.2121,
  width: 7.772,
  height: 0.77092,
  opacity: 0.9868,
  strokeWidth: 0.28594
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(25.605 5.4331 1.7591)",
  d: "m6.7823 1.2074-1.6491-0.68757 1.42-1.0844 0.11454 0.88597z",
  opacity: 0.9868,
  strokeWidth: 0.26458
})), /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.74741 .66437 -.66705 .74502 0 0)",
  x: 0.67855,
  y: -0.025902,
  width: 8.0924,
  height: 0.80722,
  opacity: 0.9868,
  strokeWidth: 0.29856
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(110.11 4.2655 3.5063)",
  d: "m6.7823 1.2074-1.6491-0.68757 1.42-1.0844 0.11454 0.88597z",
  opacity: 0.9868,
  strokeWidth: 0.26458
}));

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 7.4083 7.4083",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.2329951c.svg";
export { ForwardRef as ReactComponent };